import axios from 'axios'
import Cookies from 'js-cookie'
import { deserialise } from 'kitsu-core'
import { API_BACKEND_HOST } from 'shared/config'
import { isNil } from 'shared/lib'
import { strings } from 'shared/translations'
import { showToast } from 'shared/ui/toast/showToast'
import { keysToCamelCase } from './keysToCamelCase'
import { serialize } from './paramsSerializer'
import { transformRequest } from './transformRequest'

const secondRequest = 'second jira_sync request'

export const coreInstance = axios.create({
  baseURL: `${API_BACKEND_HOST}/api`,
  headers: {
    Authentication: import.meta.env.PROD
      ? Cookies.get('token')
      : localStorage.getItem('token'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  transformResponse: (rawResponse, _, statusCode) => {
    if (statusCode && statusCode > 199 && statusCode < 400) {
      if (!rawResponse || rawResponse === 'null') return null
      const response = JSON.parse(rawResponse)

      // TODO: need to change response for allocations filters and timetracking filters
      if (response.filters) {
        deserialise(response.filters)

        return keysToCamelCase(
          response.filters.data ? response.filters.data : response.filters,
        )
      }

      deserialise(response)

      if (isNil(response.data) || Object.keys(response).length > 1) {
        return keysToCamelCase(response)
      }

      return keysToCamelCase(response.data)
    }

    if (statusCode === 401) {
      Cookies.remove('token', { path: '' })
      localStorage.removeItem('token')
    }

    const data = JSON.parse(rawResponse)

    if (
      Array.isArray(data.errors) &&
      data.errors.some(
        (error: { error_code: string }) =>
          error.error_code === '1104' ||
          error.error_code === '1004' ||
          error.error_code === '1022' ||
          error.error_code === '1000',
      )
    )
      return

    if (data.error) {
      showToast('error', data.error)
    } else if (Array.isArray(data.errors)) {
      if (data.errors.some((error: any) => error.title === secondRequest)) {
        showToast(
          'error',
          `${strings.NOTIFICATION.JIRA_SYNC.ALREADY_IN_PROGRESS}`,
        )

        return
      }

      if (data.errors.some((error: any) => error.title)) {
        showToast(
          'error',
          data.errors.map((error: any) => error.title).join('\n'),
        )

        return
      }

      showToast('error', `${data.errors.join(', ')}`)
    } else {
      showToast('error', '')
    }
  },
  transformRequest,
  paramsSerializer: {
    serialize,
  },
})
